<template>
  <div class="ontag">
    <div style="margin: 1rem">
      <h2>Add new printer</h2>
      <div class="section">
        <span>Select club*</span><br />
        <input
          list="clubs"
          name="golfclub"
          id="golfclub-select"
          class="side-navigation--golfclub-select"
          @click="
            () => {
              selectedClub = '';
            }
          "
          v-model="selectedClub" />
        <datalist id="clubs">
          <option
            v-for="club in clubs"
            :key="club.value">
            {{ `${club.displayName}` }}
          </option>
        </datalist>
      </div>

      <div class="section">
        <span>Printer model*</span><br />
        <input
          type="radio"
          checked />Zebra direct transfer
      </div>

      <div class="section">
        <span>Serial number (12 characters)*</span><br />
        <input
          type="text"
          placeholder="D8J240402873"
          v-model="serialNumber" />
      </div>

      <div class="section">
        <span>Printer name (optional)</span><br />
        <input
          type="text"
          placeholder="Terminal"
          v-model="printerName" />
      </div>

      <div style="margin: 2rem 0rem; display: flex; gap: 1rem">
        <base-button
          backgroundColor="red"
          :text="$t('cancel')"
          :button-size-small="true"
          @click="$router.go(-1)" />

        <base-button
          class="search-button"
          :text="$t('addPrinter')"
          :button-size-small="true"
          @click="addPrinter()"
          :disabled="!canSave" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import elementLoader from '@/directives/element-loader';

export default {
  name: 'AllPrinters',
  components: {
    BaseButton,
  },
  directives: {
    elementLoader,
  },
  data() {
    return {
      // isLoading: true,
      printerName: '',
      selectedClub: '',
      serialNumber: '',
      printerType: '',
    };
  },
  methods: {
    addPrinter() {
      let club = this.clubs.find(
        c => c.displayName.trim() === this.selectedClub.trim()
      );
      this.$store
        .dispatch('printers/addPrinter', {
          club: club.value,
          serialNumber: this.serialNumber,
          printerName: this.printerName,
          printerType: this.printerType,
        })
        .then(data => {});
    },
  },
  computed: {
    clubs() {
      return this.$store.getters['clubs/clubsSelect'];
    },
    canSave() {
      return this.serialNumber.length === 12 && this.selectedClub.length > 0;
    },
  },
  created() {},
};
</script>
<style lang="scss">
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
}
.section {
  padding: 1rem;
}
</style>
